import React, { Component } from "react";
import { Form, Grid } from "semantic-ui-react";
import NumberFormat from "react-number-format";
import InlineError from "../../messages/InlineError";
import { ERR_TEXTBOX_NOT_FILLED } from "../../../ErrorMessages";

class PhoneControl extends Component {
  constructor(props) {
    super(props);
    this.formPhoneRef = React.createRef();
    this.state = {
      value: props.defaultData === undefined ? "" : props.defaultData,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.firstErrorFieldName &&
      nextProps.firstErrorFieldName === nextProps.control.FieldName
    ) {
      setTimeout(() => {
        this.formPhoneRef.current.toggle();
      }, 100);
    }
    this.setState({
      value: nextProps.defaultData === undefined ? "" : nextProps.defaultData,
    });
  }

  onPhoneValueChange = (name, value) => {
    let phone = "";
    if (value.length <= 3) {
      phone = value;
    }
    if (value.length > 3 && value.length <= 6) {
      phone = `${value.substring(0, 3)}-`;
      if (value.length > 3) {
        phone += `${value.substring(3, value.length)}`;
      }
    } else if (value.length > 6) {
      phone = `${value.substring(0, 3)}-`;
      phone += `${value.substring(3, 6)}-`;
      if (value.length > 10) {
        phone += `${value.substring(6, 10)}`;
      } else {
        phone += `${value.substring(6, value.length)}`;
      }
    }
    if (this.props.notifyChangeToForm !== undefined)
      this.props.notifyChangeToForm(this, {
        name,
        value: phone,
      });
  };

  render() {
    const { control, isLeftSearch } = this.props;
    const color = control.FieldRequired ? "red" : "black";
    return (
      <Grid.Row key={`ph_${control.FieldId}`}>
        <Grid.Column width={isLeftSearch ? 6 : 6}>
          <Form.Field>
            <label
              htmlFor={control.FieldLabel}
              style={{ color }}
              className="padding-5"
            >
              {control.FieldLabel}
            </label>
          </Form.Field>
        </Grid.Column>
        <Grid.Column width={isLeftSearch ? 10 : 10}>
          <Form.Field error={!!control.error}>
            <NumberFormat
              id={control.FieldId}
              key={`phone_${control.FormId}_${control.FieldId}`}
              format="(###) ###-####"
              placeholder={control.FieldLabel}
              name={control.FieldName}
              value={this.state.value}
              onValueChange={(values) => {
                this.onPhoneValueChange(control.FieldName, values.value);
              }}
              ref={this.formPhoneRef}
            />
            {this.props.errors[control.FieldName] !== undefined &&
              this.props.errors[control.FieldName] !== "" && (
                <InlineError text={ERR_TEXTBOX_NOT_FILLED} />
              )}
          </Form.Field>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default PhoneControl;



// WEBPACK FOOTER //
// ./src/components/forms/controls/PhoneControl.js